import Vue from 'vue'
import Router from 'vue-router'

// Auth Views
const login = () => import('@/components/loginView')
const signUpAlt = () => import('@/components/signUpPass')
const signUpConformation = () => import('@/components/signUpConformationView')

// Error Views
const error404 = () => import('@/components/404View')

// Test Views
const test = () => import('@/components/testView')

// Admin Views
const adminIndex = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/index')
const adminDashboard = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/dashboardView')
const manageWorkouts = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/manageWorkoutsView')
const manageWorkout = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/manageWorkoutView')
const manageUsers = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/users/manageUsersView')
const manageUser = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/users/manageUserView')
const manageUserProfile = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/users/partials/manageUserProfile')
const manageUserWorkouts = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/users/partials/manageUserWorkouts')
const manageUserPhotos = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/users/partials/manageUserPhotos')
const exerciseTools = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/exerciseToolsView')
const manageFeedback = () => import(/* webpackChunkName: "admin-chunk" */ '@/components/admin/manageFeedbackView')

// Members Views
const membersIndex = () => import('@/components/members/index')
const membersHome = () => import('@/components/members/homeViewAlt')
const nutrition = () => import('@/components/members/nutritionView')
const workouts = () => import('@/components/members/workoutsView')
const workoutsShow = () => import('@/components/members/workoutsShow')
const feedback = () => import('@/components/members/feedbackView')
const feedbackShow = () => import('@/components/members/feedbackShowView')
const reportShow = () => import('@/components/members/reportShowView')
const Settings = () => import('@/components/members/settingsView')
const addPhotos = () => import('@/components/members/addPhotosView')
const addGoals = () => import('@/components/members/addGoalsView')
const addMeasurements = () => import('@/components/members/addMeasurementsView')
const checkinInfo = () => import('@/components/members/static/checkinInfo')

Vue.use(Router)

export default [
  { path: '/', redirect: '/login', meta: {layout: 'guest'} },
  { path: '*', component: error404, meta: {layout: 'guest'} },
  {
    path: '/login',
    name: 'Login',
    component: login,
    meta: {layout: 'guest', guestOnly: true}
  },
  {
    path: '/signUp',
    name: 'Sign Up',
    component: signUpAlt,
    meta: {layout: 'guest', guestOnly: true}
  },
  {
    path: '/signUpConformation',
    name: 'Sign Up Conformation',
    component: signUpConformation,
    meta: {layout: 'guest', guestOnly: true}
  },
  { path: '/admin',
    component: adminIndex,

    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: adminDashboard,
        meta: {layout: 'admin', requiresAuth: true, requiresAdmin: true}
      },
      {
        path: 'workouts',
        name: 'Manage Workouts',
        component: manageWorkouts,
        props: (route) => ({
          ...route.params
        }),
        meta: {layout: 'admin', noPadding: true, requiresAuth: true, requiresAdmin: true}
      },
      {
        path: 'workouts/createTemplate',
        name: 'Create Template',
        component: manageWorkout,
        props: true,
        meta: {layout: 'simple', noPadding: true, requiresAuth: true, requiresAdmin: true}
      },
      {
        path: 'workouts/:userId',
        name: 'Create Workout',
        component: manageWorkout,
        props: true,
        meta: {layout: 'simple', noPadding: true, requiresAuth: true, requiresAdmin: true}
      },
      {
        path: 'workouts/:workoutId/editAlt',
        name: 'Edit Workout',
        component: manageWorkout,
        props: true,
        meta: {layout: 'simple', noPadding: true, requiresAuth: true, requiresAdmin: true}
      },
      {
        path: 'users',
        name: 'Manage Users',
        component: manageUsers,
        meta: {layout: 'admin', noPadding: true, requiresAuth: true, requiresAdmin: true}
      },
      {
        path: 'users/:userId',
        name: 'Manage User',
        component: manageUser,
        props: (route) => ({
          ...route.params
        }),
        children: [
          {
            path: 'profile',
            name: 'Manage User Profile',
            component: manageUserProfile,
            props: (route) => ({
              ...route.params
            }),
            meta: {layout: 'admin', noPadding: true, requiresAuth: true, requiresAdmin: true}
          },
          {
            path: 'workouts',
            name: 'Manage User Workouts',
            component: manageUserWorkouts,
            props: (route) => ({
              ...route.params
            }),
            meta: {layout: 'admin', noPadding: true, requiresAuth: true, requiresAdmin: true}
          },
          {
            path: 'photos',
            name: 'Manage User Photos',
            component: manageUserPhotos,
            props: (route) => ({
              ...route.params
            }),
            meta: {layout: 'admin', noPadding: true, requiresAuth: true, requiresAdmin: true}
          },
          {
            path: '',
            redirect: '/profile'
          }
        ]
      },
      {
        path: 'manageFeedback/',
        name: 'Manage Feedback',
        component: manageFeedback,
        meta: {layout: 'admin', noPadding: true, requiresAuth: true, requiresAdmin: true}
      },
      {
        path: '/exercises',
        name: 'Exercise Tools',
        meta: {layout: 'admin', noPadding: false, transition: 'slide-right', enter: 'slideInRight', leave: 'slideOutRight', requiresAdmin: true},
        component: exerciseTools
      }
    ]
  },
  {
    path: '/member',
    component: membersIndex,
    children: [
      {
        path: 'test',
        name: 'Test Page',
        component: test,
        meta: {layout: 'simple', image: 'woman', requiresAuth: true}
      },
      {
        path: 'home',
        name: 'Home',
        component: membersHome,
        meta: {layout: 'default', image: 'woman', requiresAuth: true}
      },
      {
        path: 'nutrition',
        name: 'Nutrition',
        component: nutrition,
        meta: {layout: 'default', image: 'woman', requiresAuth: true, restrictedView: true}
      },
      {
        path: 'workouts',
        name: 'Workouts',
        component: workouts,
        meta: {layout: 'default', image: 'man', requiresAuth: true}
      },
      {
        path: 'workouts/:workoutId',
        name: 'Log workout',
        component: workoutsShow,
        // props: true,
        props: (route) => ({
          ...route.params
        }),
        meta: {layout: 'simple', noPadding: true, requiresAuth: true}
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: feedback,
        meta: {layout: 'default', image: 'yoga', requiresAuth: true}
      },
      {
        path: 'feedback/:feedbackId',
        name: 'Feedback Show',
        component: feedbackShow,
        meta: {layout: 'simple', noPadding: true, requiresAuth: true}
      },
      {
        path: 'feedback/:reportId',
        name: 'Report Show',
        component: reportShow,
        props: (route) => ({
          ...route.params
        }),
        meta: {layout: 'simple', noPadding: true, requiresAuth: true}
      },
      {
        path: '/settings',
        name: 'Member Settings',
        meta: {layout: 'simple', noPadding: true, transition: 'slide-right', enter: 'slideInRight', leave: 'slideOutRight', requiresAuth: true},
        component: Settings
      },
      {
        path: '/addPhotos',
        name: 'Add Progress Photos',
        meta: {layout: 'simple', noPadding: true, transition: 'slide-right', enter: 'slideInRight', leave: 'slideOutRight', requiresAuth: true},
        component: addPhotos
      },
      {
        path: '/addMeasurements',
        name: 'Add Measurements',
        meta: {layout: 'simple', transition: 'slide-right', enter: 'slideInRight', leave: 'slideOutRight', requiresAuth: true},
        component: addMeasurements
      },
      {
        path: '/addGoals',
        name: 'Add Weight Goals',
        meta: {layout: 'simple', transition: 'slide-right', enter: 'slideInRight', leave: 'slideOutRight', requiresAuth: true},
        component: addGoals
      },
      {
        path: '/about/checkin',
        name: 'Check-in Info',
        meta: {layout: 'simple', transition: 'slide-right', enter: 'slideInRight', leave: 'slideOutRight', requiresAuth: true},
        component: checkinInfo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js